import {useEffect} from "react";
import {useParams} from "react-router";
import isNull from "../../../../../mixin/isNull";
import {CircularProgress} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useWorkRepository from "../../../../../repository/user/useWorkRepository";
import useOrderRepository from "../../../../../repository/b2csdu/useOrderRepository";
import useSuggestionRepository from "../../../../../repository/assignment/useSuggestionRepository";
import Map from "./Map";
import useAddressRepository from "../../../../../repository/b2csdu/useAddressRepository";

export default function () {
    const {token} = useParams();
    const suggestionRepository = useSuggestionRepository();
    const addressRepository = useAddressRepository();
    const orderRepository = useOrderRepository();
    const workRepository = useWorkRepository();
    /** @type Suggestion */
    const suggestion = suggestionRepository.findOneByToken(token).select();
    /** @type Order */
    const order = orderRepository.findOneById(suggestion?.getB2csduOrderId()).select();
    /** @type Address */
    const address = addressRepository.findOneByOrderId(suggestion?.getB2csduOrderId()).select();
    /** @type Work */
    const work = workRepository.findOneById(order?.getWorkId()).select();

    useEffect(() => {
        if (isNull(suggestion)) return;

        orderRepository.findOneById(suggestion.getB2csduOrderId()).exec();
        addressRepository.findOneByOrderId(suggestion.getB2csduOrderId()).exec();
    }, [JSON.stringify(suggestion)]);

    useEffect(() => {
        if (isNull(order)) return;

        workRepository.findOneById(order.getWorkId()).exec();
    }, [JSON.stringify(order)]);

    if (isNull(address) || isNull(suggestion)) {
        return (
            <Box display="flex" justifyContent={"center"} mt={5}>
                <CircularProgress/>
            </Box>
        )
    }

    return (
        <Box>
            <Typography
                mb={2}
                textAlign={"center"}
                textTransform={"uppercase"}
                fontSize={"small"}
            >
                {address.getCity()} ({address.getPostcode()})
                : {work?.getName() ?? "loading..."}
            </Typography>
            <Map orderId={suggestion.getB2csduOrderId()}/>
        </Box>
    )
}